<template>
  <div
    class="fixed bottom-0 right-0 z-40 mr-2 bg-white overflow-hidden st-all cursor-pointer"
    @click="buttonsShown = !buttonsShown"
    :style="{ height: buttonsShown ? '145px' : '35px' }">
    <div class="text-white rounded-t p-2 leading-none text-right" style="background-color: #606060">
      <span class="inline-block -2 border rounded border-white">
        <action-icons :icon="buttonsShown ? 'caret-up' : 'caret-down'" class="w-4 h-4 inline" />
      </span>
    </div>
    <div class="border-l border-r border-gray-700 p-2 text-center">
      <p class="text-sm text-center mb-2">Te ayudamos a finalizar tu compra</p>
      <a href="https://api.whatsapp.com/send/?phone=50378615551&amp;text= ?&amp;app_absent=0" target="_blank" class="inline-block rounded-full w-16 h-16 pt-3 hover:shadow-lg hover:bg-green-600 bg-green-400"><img src="/images/icon-whatsapp.svg" alt="Whatsapp" class="inline-block align-middle w-10 h-10"></a>
      <!-- <a href="https://www.messenger.com/t/116213355066819/?messaging_source=source%3Apages%3Amessage_shortlink" target="_blank" class="inline-block rounded-full w-20 h-20 p-2"><img src="/images/icon-messenger.png" alt="Messenger" class="inline-block"></a> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'chat-buttons',
  data() {
    return {
      buttonsShown: true
    }
  }
}
</script>